import { call, put, takeLatest } from 'redux-saga/effects';

import { ApiResponse } from '../../api/callApi.js';
import * as recommendationsApi from '../../api/recommendations.js';
import { GetRecoSettingsGoal } from '../../api/recommendations.js';
import { Action } from '../../types/action.js';
import { RecoSettingsPrioritisationGoal } from '../../types/Recommendations.js';
import { recommendationsActionsGoal } from '../action/api/RecommendationsApi.js';

function* getRecosSettingsGoal(
  action: Action<GetRecoSettingsGoal>,
): Generator<any> {
  const response = yield call(
    recommendationsApi.getRecommendationsSettingsGoal,
    action.payload!,
  );

  const { success, data } =
    response as ApiResponse<RecoSettingsPrioritisationGoal>;

  if (success) {
    yield put(recommendationsActionsGoal.success(data));
  } else {
    yield put(recommendationsActionsGoal.failed(data));
  }
}

export default function* recommendationsGoalsSaga() {
  yield takeLatest(
    recommendationsActionsGoal.type.REQUEST,
    getRecosSettingsGoal,
  );
}
